import { SkeletonRows } from '@/components/Skeleton';

export const Loader = () => {
  return (
    <SkeletonRows
      rows={1}
      skeletonClassName="bg-gradient-to-r from-[var(--gray-100)] to-[var(--gray-200)]"
    />
  );
};
